export default class CreateInvoiceRequest {
    type = 1; // 1 = Temp, 2 = Perm
    companyId: string;
    locationId: string;
    weekCommencingDate: string;
    deskIds: string[] = [];
    positionIds: string[] = [];
    locationIds: string[] = [];
    purchaseOrderNumber = '';
    invoiceLineSuffix = '';
}
